import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useIntl} from 'react-intl';
import {useFormik} from 'formik';
import {LANGUAGES} from "../../../mock/languages";
import {useNotification} from "../../../context/NotificationContext";
import {createFaq} from "../../../services/faqSvc";
import {createFaqSchema} from "../../../schema/faqSchema";
import {lang} from "../../../types/lang";

export const FaqCreatePage = () => {
  const navigate = useNavigate();
  const {formatMessage} = useIntl();
  const {showNotification} = useNotification();
  const [activeTab, setActiveTab] = useState<lang>("uz");
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      question: {
        uz: '',
        ru: '',
        en: '',
      },
      answer: {
        uz: '',
        ru: '',
        en: '',
      },
    },
    validationSchema: createFaqSchema,
    onSubmit: async (values, {
      resetForm
    }) => {
      const formData = new FormData();
      formData.append('question_uz', values.question.uz);
      formData.append('question_ru', values.question.ru);
      formData.append('question_en', values.question.en);
      formData.append('answer_uz', values.answer.uz);
      formData.append('answer_ru', values.answer.ru);
      formData.append('answer_en', values.answer.en)

      try {
        const res = await createFaq(formData);
        if (res?.success) {
          showNotification("Muvaffaqiyatli", "Tezkor savol qo'shildi", "success")
          resetForm();
          setTimeout(() => {
            navigate(-1)
          }, 1000)
        }
      } catch (e) {
        showNotification("Xatolik!", "", "error")
      }
    },
  });

  const handleTabChange = (lang) => {
    setActiveTab(lang);
  };

  return (
      <div>
        <div className={"card"}>
          <div className="card-header">
            <h1 className="card-title">Tezkor qo'shish</h1>
            <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
              {LANGUAGES.map((lang) => (
                  <li className="nav-item" key={lang.key}>
                    <button
                        className={`nav-link ${activeTab === lang.key ? 'active' : ''}`}
                        onClick={() => handleTabChange(lang.key)}
                    >
                      {lang.name}
                    </button>
                  </li>
              ))}
            </ul>
          </div>
          <div className="card-body">
            <div id="kt_account_profile_details" className="collapse show">
              <form
                  className="form"
                  onSubmit={formik.handleSubmit}
                  encType="multipart/form-data"
              >
                <div className="card-body p-9">
                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">
                      Savol
                    </label>
                    <div className="col-lg-8 fv-row">
                    <textarea
                        className="form-control form-control-lg form-control-solid"
                        placeholder="Savol"
                        name={`question.${activeTab}`}
                        value={formik.values.question[activeTab]}
                        onChange={formik.handleChange}
                    />
                      {formik.touched.question?.[activeTab] && formik.errors.question?.[activeTab] && (
                          <div className="text-danger">{formik.errors.question[activeTab]}</div>
                      )}
                    </div>
                  </div>


                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">
                      Javob
                    </label>
                    <div className="col-lg-8 fv-row">
                    <textarea
                        className="form-control form-control-lg form-control-solid"
                        placeholder="Javob"
                        rows={10}
                        name={`answer.${activeTab}`}
                        value={formik.values.answer[activeTab]}
                        onChange={formik.handleChange}
                    />
                      {formik.touched.answer?.[activeTab] && formik.errors.answer?.[activeTab] && (
                          <div className="text-danger">{formik.errors.answer[activeTab]}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="justify-content-end d-flex gap-2">
                    <button
                        className="btn btn-secondary"
                        onClick={() => navigate(-1)}
                        type="button"
                    >
                      {formatMessage({id: "Bekor qilish"})}
                    </button>
                    <button
                        disabled={formik.isSubmitting}
                        className="btn btn-primary"
                        type="submit"
                    >
                      {
                        formik.isSubmitting ? "Saqlanmoqda..." : "Saqlash"
                      }
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
  );
};